module.exports = __webpack_public_path__ + "static/media/19ESCAP46.f2d9dc57.jpg";